document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('.product-grid');
  if (!grid) return;

  function addToCart(variantId, onSuccess) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        window.BIP.updateCartCount(cart.item_count);
        onSuccess();
      })
      .catch(function () {
        // The first fetch (/cart/add.js) may have already succeeded server-side even if
        // this chain rejects (e.g. the second /cart.js fetch fails). Re-enabling the button
        // would leave the UI silently out of sync with a cart that may have actually changed
        // (and risks the user clicking again, doubling the line-item quantity). Reload to
        // force a resync with true server state, matching cart.js's changeLine() fallback.
        window.location.reload();
      });
  }

  function closePopover(popover) {
    popover.hidden = true;
    var card = popover.closest('.product-card');
    var toggle = card && card.querySelector('[data-quick-add-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function showAdded(button) {
    var original = button.textContent;
    button.setAttribute('data-added', 'true');
    button.textContent = button.getAttribute('data-label-added');
    setTimeout(function () {
      button.removeAttribute('data-added');
      button.textContent = original;
      button.disabled = false;
    }, 1500);
  }

  grid.addEventListener('click', function (event) {
    var arrowButton = event.target.closest('[data-card-arrow]');
    if (arrowButton) {
      event.preventDefault();
      event.stopPropagation();
      var imageWrap = arrowButton.closest('.product-card__image');
      var slides = imageWrap.querySelectorAll('.product-card__slide');
      var currentIndex = Array.prototype.findIndex.call(slides, function (slide) {
        return slide.classList.contains('active');
      });
      var direction = arrowButton.getAttribute('data-card-arrow') === 'next' ? 1 : -1;
      var nextIndex = (currentIndex + direction + slides.length) % slides.length;
      slides[currentIndex].hidden = true;
      slides[currentIndex].classList.remove('active');
      slides[nextIndex].hidden = false;
      slides[nextIndex].classList.add('active');
      return;
    }

    var instantButton = event.target.closest('[data-quick-add-instant]');
    if (instantButton) {
      instantButton.disabled = true;
      addToCart(instantButton.getAttribute('data-variant-id'), function () {
        showAdded(instantButton);
      });
      return;
    }

    var toggleButton = event.target.closest('[data-quick-add-toggle]');
    if (toggleButton) {
      var card = toggleButton.closest('.product-card');
      var popover = card.querySelector('[data-quick-add-popover]');
      var isOpen = !popover.hidden;
      document.querySelectorAll('[data-quick-add-popover]').forEach(function (p) { closePopover(p); });
      popover.hidden = isOpen;
      toggleButton.setAttribute('aria-expanded', String(!isOpen));
      return;
    }

    var closeButton = event.target.closest('[data-quick-add-close]');
    if (closeButton) {
      var popoverToClose = closeButton.closest('[data-quick-add-popover]');
      closePopover(popoverToClose);
      return;
    }

    var optionButton = event.target.closest('[data-option-value]');
    if (optionButton) {
      var popoverEl = optionButton.closest('[data-quick-add-popover]');
      var group = optionButton.closest('[data-quick-add-option-index]');
      group.querySelectorAll('[data-option-value]').forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-pressed', 'false');
      });
      optionButton.classList.add('active');
      optionButton.setAttribute('aria-pressed', 'true');
      updateQuickAddSelection(popoverEl);
      return;
    }

    var submitButton = event.target.closest('[data-quick-add-submit]');
    if (submitButton) {
      var popoverForSubmit = submitButton.closest('[data-quick-add-popover]');
      var variantId = popoverForSubmit.querySelector('[data-quick-add-variant-id]').value;
      if (!variantId) return;
      submitButton.disabled = true;
      addToCart(variantId, function () {
        showAdded(submitButton);
        closePopover(popoverForSubmit);
      });
    }
  });

  function updateQuickAddSelection(popover) {
    var variantsEl = popover.querySelector('[data-quick-add-variants]');
    var variants = JSON.parse(variantsEl.textContent);
    var groups = popover.querySelectorAll('[data-quick-add-option-index]');
    var selected = [];

    groups.forEach(function (group) {
      var index = parseInt(group.getAttribute('data-quick-add-option-index'), 10);
      var active = group.querySelector('.active');
      selected[index] = active ? active.getAttribute('data-option-value') : null;
    });

    var match = variants.find(function (variant) {
      return variant.options.every(function (value, i) { return value === selected[i]; });
    });

    var idInput = popover.querySelector('[data-quick-add-variant-id]');
    var submitButton = popover.querySelector('[data-quick-add-submit]');

    if (match && match.available && selected.every(function (v) { return v !== undefined && v !== null; })) {
      idInput.value = match.id;
      submitButton.disabled = false;
    } else {
      idInput.value = '';
      submitButton.disabled = true;
    }
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.product-card')) {
      document.querySelectorAll('[data-quick-add-popover]').forEach(function (p) { closePopover(p); });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-quick-add-popover]').forEach(function (p) { closePopover(p); });
    }
  });
});
